import {takeLatest, call, put} from 'redux-saga/effects';
import * as directory from '../actions/directory';
import {getDirectory} from '../../api/directory';

export function* getDirectoryWorker({payload}) {
  try {
    const data = yield call(getDirectory, payload);

    if (data) {
      yield put(directory.getDirectorySuccess({error: false, data: data}));
    } else {
      yield put(directory.getDirectoryFailure({error: true, data: data}));
    }
  } catch (e) {
    yield put(directory.getDirectoryFailure({error: true, data: {}}));
  }
}

export function* getDirectoryWatcher() {
  yield takeLatest(directory.getDirectory.toString(), getDirectoryWorker);
}
